import React from 'react';
import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import Icon from '@/components/ui/Icon';
import { queryClient } from '@/utils/ReactQuery';
import { plato_api_rubric_path } from '@/modules/routes';
import { UnstyledButton } from '@/components/ui/Buttons';
import { useModalManager } from '@/components/common/Modal';
import ConfirmDeleteModal from '@/components/common/Modal/ConfirmDeleteModal';
import { IRubric } from '@/components/staffer/ExerciseBuilder/Rubric/useQuestionRubric';
import { IRubricModalQuestion } from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/AddRubricModal.types';

interface IDestroyRubricButton {
  question: IRubricModalQuestion;
  rubric: IRubric;
}

const DestroyRubricButton = ({ question, rubric }: IDestroyRubricButton) => {
  const { close, isOpen, open } = useModalManager();

  const { mutate, isLoading } = useMutation({
    mutationFn: async () => (
      axios
        .delete(plato_api_rubric_path(rubric.id, { question_id: question.id }))
        .then(() => {
          queryClient.invalidateQueries(['useRubric', { for_question: question.id }]);
        })
    ),
    mutationKey: ['destroyRubric', rubric.id],
    onSuccess: close,
  });

  return (
    <>
      <UnstyledButton className="!tw-cursor-pointer" onClick={open}>
        <Icon
          className="tw-text-red tw-pointer-events-none"
          icon="Delete"
          size={22}
        />
      </UnstyledButton>
      <ConfirmDeleteModal
        confirmationText="Are you sure you want to delete this rubric? This action cannot be undone."
        headerText="Delete Rubric"
        isLoading={isLoading}
        isOpen={isOpen}
        onCancel={close}
        onConfirm={mutate}
      />
    </>
  );
};

export default DestroyRubricButton;
